/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ModelDto as OkEgisServiceModelsDtoModelDto } from '../models/OK/Egis/Service/Models/DTO/model-dto';
import { CreateModellerRequest as OkEgisServiceModelsRequestCreateModellerRequest } from '../models/OK/Egis/Service/Models/Request/create-modeller-request';
import { GetModellerRequest as OkEgisServiceModelsRequestGetModellerRequest } from '../models/OK/Egis/Service/Models/Request/get-modeller-request';

@Injectable({
  providedIn: 'root',
})
export class ModelService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getModeller
   */
  static readonly GetModellerPath = '/api/v1/Model/GetModeller';

  /**
   * Returns a list of modeller.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getModeller()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getModeller$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetModellerRequest
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoModelDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ModelService.GetModellerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoModelDto>>;
      })
    );
  }

  /**
   * Returns a list of modeller.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getModeller$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getModeller(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetModellerRequest
  }): Observable<Array<OkEgisServiceModelsDtoModelDto>> {

    return this.getModeller$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoModelDto>>) => r.body as Array<OkEgisServiceModelsDtoModelDto>)
    );
  }

  /**
   * Path part for operation getModellerForFabrikat
   */
  static readonly GetModellerForFabrikatPath = '/api/v1/Model/GetModellerForFabrikat';

  /**
   * Returns a list of modeller.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getModellerForFabrikat()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModellerForFabrikat$Response(params: {
    fabrikatId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoModelDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ModelService.GetModellerForFabrikatPath, 'get');
    if (params) {
      rb.query('fabrikatId', params.fabrikatId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoModelDto>>;
      })
    );
  }

  /**
   * Returns a list of modeller.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getModellerForFabrikat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModellerForFabrikat(params: {
    fabrikatId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoModelDto>> {

    return this.getModellerForFabrikat$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoModelDto>>) => r.body as Array<OkEgisServiceModelsDtoModelDto>)
    );
  }

  /**
   * Path part for operation createModeller
   */
  static readonly CreateModellerPath = '/api/v1/Model/CreateModeller';

  /**
   * Creates Modeller.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createModeller()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModeller$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestCreateModellerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoModelDto>> {

    const rb = new RequestBuilder(this.rootUrl, ModelService.CreateModellerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoModelDto>;
      })
    );
  }

  /**
   * Creates Modeller.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createModeller$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModeller(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestCreateModellerRequest
  }): Observable<OkEgisServiceModelsDtoModelDto> {

    return this.createModeller$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoModelDto>) => r.body as OkEgisServiceModelsDtoModelDto)
    );
  }

  /**
   * Path part for operation updateModel
   */
  static readonly UpdateModelPath = '/api/v1/Model/{modelId}';

  /**
   * Updates a model.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateModel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateModel$Response(params: {
    modelId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoModelDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoModelDto>> {

    const rb = new RequestBuilder(this.rootUrl, ModelService.UpdateModelPath, 'put');
    if (params) {
      rb.path('modelId', params.modelId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoModelDto>;
      })
    );
  }

  /**
   * Updates a model.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateModel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateModel(params: {
    modelId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoModelDto
  }): Observable<OkEgisServiceModelsDtoModelDto> {

    return this.updateModel$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoModelDto>) => r.body as OkEgisServiceModelsDtoModelDto)
    );
  }

}
